'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.InversionModalWindow', []).directive('rmInversionModalWindow', require('./directives/InversionModalDirective')).directive('rmMappedInversionModalWindow', require('./directives/MappedInversionModalDirective'));